import { ListTodo } from 'lucide-react';
import { cn } from '@/lib/utils';
import { WeeklyTask } from '@/hooks/useWeeklyTasks';
import { WeeklyTaskSlotCard } from './WeeklyTaskSlotCard';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';

interface UnscheduledTasksDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tasks: WeeklyTask[];
  weekOffset: number;
  onEditTask: (task: WeeklyTask) => void;
  users: { id: string; name: string; color: string; textColor: string }[];
}

export function UnscheduledTasksDrawer({
  open,
  onOpenChange,
  tasks,
  weekOffset,
  onEditTask,
  users
}: UnscheduledTasksDrawerProps) {
  const uncompletedCount = tasks.filter(t => !t.isCompleted).length;

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerTrigger asChild>
        <button
          className={cn(
            "fixed bottom-4 left-4 right-4 mx-auto",
            "flex items-center justify-center gap-2",
            "bg-slate-800 border border-slate-600 rounded-2xl",
            "py-3 px-4 shadow-lg",
            "transition-all duration-200 active:scale-95"
          )}
        >
          <ListTodo className="h-5 w-5 text-skylight-blue" />
          <span className="text-sm font-medium text-slate-200">
            לבצע השבוע
          </span>
          {uncompletedCount > 0 && (
            <span className="bg-skylight-blue text-white text-xs font-bold px-2 py-0.5 rounded-full">
              {uncompletedCount}
            </span>
          )}
        </button>
      </DrawerTrigger>
      
      <DrawerContent className="bg-slate-800 border-slate-700">
        <DrawerHeader className="border-b border-slate-700">
          <DrawerTitle className="flex items-center justify-center gap-2 text-slate-100">
            <ListTodo className="h-5 w-5 text-skylight-blue" />
            לבצע השבוע
            <span className="text-sm text-slate-400">
              ({tasks.length} משימות)
            </span>
          </DrawerTitle>
        </DrawerHeader>
        
        <div className="p-4 max-h-[60vh] overflow-y-auto">
          {tasks.length === 0 ? (
            <div className="text-center text-slate-500 py-8">
              אין משימות ללא יום מתוזמן
            </div>
          ) : (
            <div className="space-y-3">
              {tasks.map((task) => {
                const user = users.find(u => u.id === task.user_name);
                return (
                  <WeeklyTaskSlotCard
                    key={task.id}
                    task={task}
                    user={user}
                    hour={null}
                    weekOffset={weekOffset}
                    onEditClick={onEditTask}
                  />
                );
              })}
            </div>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
